module.exports = __webpack_public_path__ + "img/0445_19.35cde5e3.jpg";